import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Booking } from '@/hooks/useBookings';

export const usePublicBookingByShortId = (bookingId: string) => {
  return useQuery({
    queryKey: ['public-booking', bookingId],
    queryFn: async (): Promise<Booking | null> => {
      console.log(`🏨 Fetching public booking with ID: ${bookingId}`);
      
      const { data: booking, error } = await supabase
        .from('bookings')
        .select(`
          *,
          origins (
            name
          )
        `)
        .eq('booking_id', bookingId)
        .maybeSingle();

      if (error) {
        console.error('Error fetching booking:', error);
        throw error;
      }

      if (!booking) {
        console.log('Booking not found');
        return null;
      }

      console.log('✅ Booking fetched successfully');
      return {
        ...booking,
        status: booking.status as 'Reservada' | 'Cancelada'
      } as Booking;
    },
    enabled: !!bookingId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
